// extracted by mini-css-extract-plugin
export default {"copyIconSVG":"CopyIconSVG__copyIconSVG___SlzQ7"};